import { Navigate, Outlet } from 'react-router-dom';
import { APP_PATHS } from '../../constants/paths';
import { useAuth } from '../../hooks/useAuth/useAuth';

export const HoldingRoute = () => {
  const { isSignedIn } = useAuth();

  if (!isSignedIn && process.env.REACT_APP_LOCAL_DEV !== 'true') {
    return <Navigate to={APP_PATHS.login} />;
  }

  return <Outlet />;
};
